import React, { useCallback, useEffect, useState } from "react";
import { useGlobalContext } from "../../../../../context/global/state";
import { Grid } from "react-bootstrap";
import Customize from "../../../../../components/controllers/shared/helpers/customize";
import { app as App } from "context/global/data";
import { Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";

// TODO: Need noPlanName and noLogo logic, refer to containers/templates/elements/menu/mainMenu.tsx
type Content = {
	header: string;
	contract: string;
	isMember: boolean;
	context: string;
};

const AccountPlanHeader: React.FC = () => {
	const { data, nav } = useGlobalContext();
	const history = useHistory();
	const [content, setContent] = useState<Content | null>(null);
	const { clientLogoSrc } = App;

	const updateContent = useCallback(
		(historyObj) => {
			const context = nav.getSiteContext(history);
			const isMember = context.includes("member");

			const accountPlanHeader = data[context]?.accountPlanHeader || {};
			const planName = Customize.planName(accountPlanHeader.planName);
			const contract = isMember ? planName : accountPlanHeader?.contract;
			const header = isMember
				? accountPlanHeader.planTypeDescription
				: planName;

			setContent({
				header,
				contract,
				context,
				isMember,
			});
		},
		[history, data, nav],
	);

	// Init content
	useEffect(() => {
		if (!content) updateContent(history);
	}, [content, updateContent, history]);

	// Change content on path changes
	useEffect(() => {
		const listener = history.listen((historyObj) =>
			updateContent(historyObj),
		);
		return () => listener();
	}, [history, updateContent]);

	// Contract/Info Elements
	const employerContract = (
		<p className="util-margin-top-5" style={{ fontSize: "14px" }}>
			Contract Number: {content?.contract}
		</p>
	);
	const memberInfo = (
		<p className="util-margin-top-5" style={{ fontSize: "14px" }}>
			John Customer - {content?.contract}
		</p>
	);

	const imageProps = {
		className: "pull-right hidden-xs hidden-sm demo-company",
		style: { maxWidth: "300px", maxHeight: "55px" },
		src: clientLogoSrc,
		alt: "Demo company logo",
	};

	return (
		<section className="title">
			<Grid>
				<div>
					<Image {...imageProps} />
					<h1 className="h2">{content?.header}</h1>
					{content?.isMember ? memberInfo : employerContract}
				</div>
			</Grid>
		</section>
	);
};

export default AccountPlanHeader;
